import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error cannot find module
import iconUrl from 'bender-url!../../../../img/logo/connect-full-logo-white.svg';
import I18n from 'I18n';

const FooterCopyright = () => {
  return /*#__PURE__*/_jsx("img", {
    src: iconUrl,
    height: "29px",
    alt: I18n.text(`app.footer.logo`)
  });
};

export default FooterCopyright;